export default {
    url: '/histograms',
    template: require('./view.html'),
    data: {
        title: 'Histograms',
        role: 'video',
        priority: 807,
    },
    reloadOnSearch: false,
};
